import React from 'react'
import PropTypes from 'prop-types'

function IconMoney(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 74 75"
    >
      <ellipse
        fill="#de9239"
        cx="35.5"
        cy="35"
        rx="35.5"
        ry="35"
        transform="translate(0 5)"
      />
      <circle fill="#f9ad55" cx="35" cy="35" r="35" transform="translate(4)" />
      <g transform="translate(22.398 19.461)">
        <path
          fill="#de9239"
          d="M121.519,114.645h-1.87a13.3,13.3,0,0,0,.079-1.444c0-.375-.017-.747-.047-1.114h1.839a2.359,2.359,0,1,0,0-4.718h-3.151a13.225,13.225,0,0,0-11.851-7.378H97.31a2.359,2.359,0,0,0-2.359,2.359v5.019H92.929a2.359,2.359,0,0,0,0,4.718h2.022v2.558H92.929a2.359,2.359,0,0,0,0,4.718h2.022v12.378a2.359,2.359,0,0,0,4.718,0v-5.33h6.849a13.222,13.222,0,0,0,11.682-7.049h3.319a2.359,2.359,0,0,0,0-4.718Zm-21.85-9.936h6.849a8.467,8.467,0,0,1,6.164,2.66H99.669Zm6.849,16.985H99.669v-2.33h12.684A8.46,8.46,0,0,1,106.518,121.694Zm8.367-7.049H99.669v-2.558h15.266a8.331,8.331,0,0,1-.05,2.558Z"
          transform="translate(-90.57 -99.991)"
        />
        <path
          fill="#fff"
          d="M146.521,114.645h-1.87a13.3,13.3,0,0,0,.079-1.444c0-.375-.017-.747-.047-1.114h1.839a2.359,2.359,0,1,0,0-4.718H143.37a13.225,13.225,0,0,0-11.851-7.378h-9.208a2.359,2.359,0,0,0-2.359,2.359v5.019h-2.022a2.359,2.359,0,1,0,0,4.718h2.022v2.558h-2.022a2.359,2.359,0,1,0,0,4.718h2.022v12.378a2.359,2.359,0,0,0,4.718,0v-5.33h6.849a13.222,13.222,0,0,0,11.682-7.049h3.319a2.359,2.359,0,0,0,0-4.718Zm-21.85-9.936h6.849a8.467,8.467,0,0,1,6.164,2.66H124.671Zm6.849,16.985h-6.849v-2.33h12.684A8.46,8.46,0,0,1,131.519,121.694Zm8.367-7.049H124.671v-2.558h15.266a8.326,8.326,0,0,1-.05,2.558Z"
          transform="translate(-112.623 -99.991)"
        />
      </g>
    </svg>
  )
}

IconMoney.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

IconMoney.defaultProps = {
  width: 60,
  height: 60,
}

export default IconMoney
